const constants = {
  ROUTES: {
    HOME: "/home",
    CONTACT_US: "/contactUs",
    LOGIN: "/login",
  },
  HTTP_REQ_DEFAULT_HEADERS: {
    Accept: "application/json",
    "Content-Type": "application/json; charset=UTF-8",
  },
  HTTP_MULTIPART_FORM_HEADERS: {
    Accept: "application/json",
    "Content-Type": "application/json; charset=UTF-8",
  },
  HTTP_METHODS: {
    POST: "POST",
    GET: "GET",
    DELETE: "DELETE",
    PATCH: "PATCH",
    PUT: "PUT",
  },

  HOME: {
    WELCOME: "WELCOME TO",
  },
  ROLES: {
    CP_ADMIN: "ROLE_CPADMIN",
    HO_ADMIN: "ROLE_HOADMIN",
    HUB_ADMIN: "ROLE_HUBADMIN",
    CP_OPERATOR: "ROLE_CPOPERATOR",
  }
};

export default constants;
